import React from 'react';
import { Button, Flex, Image } from '@chakra-ui/react';
import { useRouteMatch } from "react-router-dom";
// sidebar menu icons
import Dashboard from "../../images/sidebar/dashboard.svg";
import DashboardActive from "../../images/sidebar/dashboard-active.svg";
import Classes from "../../images/sidebar/classes.svg";
import ClassesActive from "../../images/sidebar/classes-active.svg";
import Assignments from "../../images/sidebar/assignments.svg";
import AssignmentsActive from "../../images/sidebar/assignments-active.svg";
import Notes from "../../images/sidebar/notes.svg";
import NotesActive from "../../images/sidebar/notes-active.svg";
import Lessons from "../../images/sidebar/lessons.svg";
import LessonsActive from "../../images/sidebar/lessons-active.svg";
// menu icons
import Chevron from "../../images/sidebar/chevron.svg";
import { Props } from '../../interfaces/interfaces';
import MenuLinks from '../utilities/MenuLinks';
import Logo from '../utilities/Logo';
import { useStudentAuthDispatch } from "../../store/store";
import { studentLogout } from "../../action/studentAction";
import { teacherLogout } from "../../action/teacherAction";

export default function SideBar({ menuContent, closeMenu }: Props) {
  let { url } = useRouteMatch();
  //let history = useHistory();
  const dispatch = useStudentAuthDispatch();

  // console.log(path, url, params, window.location.pathname);

  function signOut(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    console.log('sign out button clicked');
    if (url === "/student") {
      localStorage.removeItem("vidcom");
      return dispatch(studentLogout());
    }
    dispatch(teacherLogout());
    localStorage.removeItem("vidcom");
  }

  return (
    <Flex flex={{ base: "0.25", lg: "0.3" }} display={{ base: `${menuContent ? "flex" : "none"}`, lg: "flex" }}
      w={{ base: `${menuContent ? "240px" : "0"}`, lg: "300px" }} h="100vh" flexDirection="column"
      alignItems="center" pos="fixed" padding="2px 20px" bgColor="white" boxShadow="2xl" zIndex={3}>
      <Image
        boxSize="30px"
        objectFit="cover"
        display={{ base: "flex", lg: "none" }}
        src={Chevron}
        alt="menu close icon"
        float="right"
        pos="absolute"
        top="50%"
        left="93.5%"
        onClick={closeMenu}
      />
      <Logo _fontSize={"2rem"} _mt={8} />
      <Flex flexDirection="column" flex="0.9" justifyContent="center" w={{ base: "240px", lg: "300px" }}
        padding={{ base: "0 35px", lg: "0 60px" }}>
        {/* use url to show the links for student or tutor */}
        {url.match("/student") ? (<>
          <MenuLinks status={true} linkUrl={url} linkName={"dashboard"} imgActive={DashboardActive}
            img={Dashboard} altText={"home"} />
          <MenuLinks status={false} linkUrl={`${url}/classes`} linkName={"classes"} imgActive={ClassesActive}
            img={Classes} altText={"classes"} />
          <MenuLinks status={false} linkUrl={`${url}/assignments`} linkName={"assignments"}
            imgActive={AssignmentsActive} img={Assignments} altText={"assignments"} />
          <MenuLinks status={false} linkUrl={`${url}/notes`} linkName={"notes"} imgActive={NotesActive}
            img={Notes} altText={"notes"} />
          <MenuLinks status={false} linkUrl={`${url}/lessons`} linkName={"lessons"} imgActive={LessonsActive}
            img={Lessons} altText={"lessons"} />
        </>) :
          url.match("/tutor") && (<>
            <MenuLinks status={true} linkUrl={url} linkName={"dashboard"} imgActive={DashboardActive}
              img={Dashboard} altText={"home"} />
            <MenuLinks status={false} linkUrl={`${url}/classes`} linkName={"classes"} imgActive={ClassesActive}
              img={Classes} altText={"classes"} />
            <MenuLinks status={false} linkUrl={`${url}/assignments`} linkName={"assignments"}
              imgActive={AssignmentsActive} img={Assignments} altText={"assignments"} />
            <MenuLinks status={false} linkUrl={`${url}/notes`} linkName={"notes"} imgActive={NotesActive}
              img={Notes} altText={"notes"} />
            <MenuLinks status={false} linkUrl={`${url}/lessons`} linkName={"lessons"} imgActive={LessonsActive}
              img={Lessons} altText={"lessons"} />
          </>)}
      </Flex>
      <Button
        textTransform="capitalize"
        p={{ base: "25px 50px", lg: "25px 70px" }}
        bgColor="grey"
        color="black"
        borderRadius="20px"
        onClick={(e) => signOut(e)}
      >
        sign out
      </Button>
    </Flex>
  )
}
